import { buildWorkOrderDraftResponseDto } from "@/builder";
import { buildWorkOrderFormState } from "./resource";
import { State } from "./types";

export const state: State = {
  form: buildWorkOrderFormState(),
  detail: buildWorkOrderDraftResponseDto(),
};
